import { useEffect } from "react";
import HeaderV2 from "./v2/header";
import dynamic from "next/dynamic";
const FooterV2 = dynamic(() => import("../components/v2/footer"), {
  ssr: true,
});
export default function Layout({
  isHomePage,
  children,
  ogImage,
  pageTitle,
}: {
  isHomePage?: boolean | undefined;
  children?: React.ReactNode;
  ogImage: any;
  pageTitle: any;
  uri: any;
  metaTitle: any;
  metaDesc: any;
  metaRobotsNoindex: any;
  metaRobotsNofollow: any;
  hasDynamicFAQ?: boolean;
}) {
  let openGraphImage =
    ogImage != undefined
      ? ogImage
      : "https://middleware.io/wp-content/uploads/2024/08/middleware-observability-thumbnail.png";

  if (openGraphImage.indexOf("/backend/") > -1) {
    openGraphImage = openGraphImage.split("/backend/").join("/");
  }

  // useEffect(() => {
  //   if ("serviceWorker" in navigator) {
  //     navigator.serviceWorker.getRegistrations().then((registrations) => {
  //       for (let registration of registrations) {
  //         registration.unregister();
  //       }
  //     });
  //   }
  // }, []);

  const setCookie = (cname: string, cvalue: string, exdays: number) => {
    const d = new Date();
    d.setTime(d.getTime() + exdays * 24 * 60 * 60 * 1000);
    let expires = "expires=" + d.toUTCString();
    document.cookie =
      cname +
      "=" +
      cvalue +
      ";" +
      expires +
      ";path=/;domain=.middleware.io;SameSite=None;Secure";
  };

  useEffect(() => {
    const currentUrl = window.location.href;
    setCookie("mw_website_current_url", encodeURIComponent(currentUrl), 365);
  }, [pageTitle]);
  return (
    <>
      {/*Google Tag Manager (noscript)*/}
      <noscript>
        <iframe
          src="https://www.googletagmanager.com/ns.html?id=GTM-KKBGSWD"
          height="0"
          width="0"
          style={{ display: "none", visibility: "hidden" }}
        ></iframe>
      </noscript>

      <div className={`global-wrapper-v2`} data-is-root-path={isHomePage}>
        {/*<Seo uri={uri} ogImage={openGraphImage} title={pageTitle ? pageTitle :''} metaTitle={metaTitle ? metaTitle : ""} metaDesc={metaDesc} description={metaDesc} robots={`${metaRobotsNoindex}, ${metaRobotsNofollow}`} />*/}
        <HeaderV2 />

        <main>{children}</main>
        <FooterV2 />
      </div>
    </>
  );
}
